import React, { useRef, useState, useEffect, useMemo } from "react";
import Select from "~components/Form/components/Select";
import useTodasCidades from "~fetchs/useTodasCidades";
import useTodosSegmentos from "~fetchs/useTodosSegmentos";
import useTrilha from "~fetchs/useTrilha";
import { CleanFiltersIcon } from "~misc/icons";
import "./styles.scss";
import useTodasMicroRegioes from "~fetchs/useTodasMicroRegioes";
import useBloqueado from "~fetchs/useBloqueado";
import useTipoPessoa from "~fetchs/useTipoPessoa";

const SearchClient = ({ onChangeFilters, setClickClear, todosOsClientes, vendedorSelecionado,setTipoPessoaStatus, setBloqueadoStatus,  filtros, buttonClear, setButtonClear }) => {
  const formikRef = useRef();

  const [keys, setKeys] = useState({
    segmentoId: `select-carteira-segmento`,
    trilhaId: `select-carteira-trilha`,
    cidadeId: `select-carteira-cidade`,
    microrregiao: `select-carteira-microrregiao`,
    bloqueado: `select-carteira-bloqueado`,
    tipo: `select-carteira-tipo`,
  });
  const { optionsTrilha, trilha, onChangeTrilha, trilhaSelect } = useTrilha(formikRef, {
    salvarLocalStorage: true,
    chave: keys.trilhaId,
  });
    const { selectMicro, optionMicroRegioes, microRegiao, microRegiaoSelect, onChangeMicroRegiao } =
    useTodasMicroRegioes(todosOsClientes, { salvarLocalStorage: true, chave: keys.microrregiao });
  const { segmentoSelect, onChangeSegmento, segmento, optionsSegmento } = useTodosSegmentos(
    todosOsClientes,
    trilha,
    formikRef,
    { salvarLocalStorage: true, chave: keys.segmentoId }
  );

const { optionCidades, onChangeCidade, cidade, cidadeSelect } = useTodasCidades(
    todosOsClientes,
    selectMicro,
    filtros,
     { salvarLocalStorage: true, chave: keys.cidadeId }
  );
  const {
    bloqueado,
    optionsBloqueado,
    bloqueadoSelect,
    onChangeBloqueado,
  } = useBloqueado(todosOsClientes, setBloqueadoStatus, { salvarLocalStorage: true, chave: keys.bloqueado });


  const {
  tipo,
  optionsTipoPessoa,
  tipoPessoaSelect,
  onChangeTipo,
} = useTipoPessoa(setTipoPessoaStatus, { salvarLocalStorage: true, chave: keys.tipo });

  const previousFiltersKeyRef = useRef(null);

  const [temBloqueado, setTemBloqueado] = useState(null);
  const [tipoVariado, setTipo] = useState(null);
  const [temSegmento, setTemSegmento] = useState(false);
  const [temTrilha, setTemTrilha] = useState(false);
  const [temCidade, setTemCidade] = useState(false);
  const [temMicro, setTemMicro] = useState(false);

  useEffect(() => {
    if (!Array.isArray(todosOsClientes) || todosOsClientes.length === 0) {
      setTemBloqueado(null);
      setTipo(null);
      setTemSegmento(null);
      setTemTrilha(null);
      setTemCidade(null);
      setTemMicro(null);

      return;
    }

    const algumBloqueado = todosOsClientes.some((cliente) => cliente.bloqueado === true);
    setTemBloqueado(algumBloqueado);
    const categoriasTipoCliente = new Set();
    todosOsClientes.forEach((cliente) => {
      if (cliente.clienteProspect === 1) {
        categoriasTipoCliente.add("prospect");
      } else if (cliente.tipo === 1 || cliente.tipo === 2) {
        categoriasTipoCliente.add("emissorRecebedor");
      } else if (cliente.tipo === 3 || cliente.tipo === 4) {
        categoriasTipoCliente.add("recebedor");
      }
    });
    setTipo(categoriasTipoCliente.size > 1);

    const segmentosUnicos = new Set(todosOsClientes.map((c) => c.segmentoId).filter(Boolean));
    setTemSegmento(segmentosUnicos.size > 1);

    const trilhasUnicas = new Set(todosOsClientes.map((c) => c.trilhaId).filter(Boolean));
    setTemTrilha(trilhasUnicas.size > 1);

    const cidadesUnicas = new Set(todosOsClientes.map((c) => c.endereco?.cidade?.id).filter(Boolean));
    setTemCidade(cidadesUnicas.size > 1);

    const microrregioesUnicas = new Set(todosOsClientes.map((c) => c.microrregiaoId).filter(Boolean));
    setTemMicro(microrregioesUnicas.size > 1);
  }, [todosOsClientes]);

  const optionsTrilhaFiltradas = useMemo(() => {
    if (!Array.isArray(todosOsClientes) || todosOsClientes.length === 0) return [];
    const trilhasUsadas = new Set(
      todosOsClientes
        .map((cliente) => cliente.trilhaId ?? cliente.trilha?.id)
        .filter((id) => typeof id === "number" || typeof id === "string")
    );
    return optionsTrilha.filter((option) => trilhasUsadas.has(option.value));
  }, [todosOsClientes, optionsTrilha]);

  const buttonRef = useRef();

  const currentFilters = useMemo(
    () => ({
      segmentoId: segmento ?? 0,
      trilhaId: trilha ?? 0,
      cidadeId: cidade ?? 0,
      microrregiao: microRegiao ?? 0,
      tipo: tipo ?? 0,
      bloqueado: bloqueado ?? 0,
    }),
    [segmento, trilha, cidade, microRegiao, tipo, bloqueado]
  );

  useEffect(() => {
    const filtersKey = JSON.stringify(currentFilters);

    if (previousFiltersKeyRef.current === filtersKey) {
      return;
    }

    previousFiltersKeyRef.current = filtersKey;
    onChangeFilters?.(currentFilters);
  }, [currentFilters, onChangeFilters]);
  useEffect(() => {

    if (!buttonClear) return;
    const pathname = window.location.pathname;
    const key = `${pathname}-listagem`;
    localStorage.removeItem(key);

    onChangeSegmento({ value: 0, label: "Todos" });
    onChangeTrilha({ value: 0, label: "Todos" });
    onChangeCidade({ value: 0, label: "Todos" });
    onChangeMicroRegiao({ value: 0, label: "Todas" });
    onChangeBloqueado({ value: 0, label: "Todos" });
    onChangeTipo({ value: 0, label: "Todos" });

    onChangeFilters?.({
      segmentoId: 0,
      trilhaId: 0,
      microrregiao: 0,
      cidadeId: 0,
      tipo: 0,
      bloqueado: 0,
    });
    setTimeout(() => {
      setButtonClear(false);
    }, 1000);
  }, [buttonClear]);



  const prependTodosOption = (options) => [{ value: 0, label: "Todos" }, ...(options || [])];

  return (
    <>
      <div
        className="container container-carteira grid pt-8 grid-cols-1 md:grid-cols-3 gap-x-3 gap-y-4 bg-white px-6 border-terciaria border-x
"
      >
        <Select
          name="trilhaId"
          label="Trilha Global:"
          placeholder="Trilha Global:"
          options={prependTodosOption(optionsTrilhaFiltradas)}
          noOptionsMessage="Trilha não encontrada"
          onChange={onChangeTrilha}
          isDisabled={!temTrilha}
          {...trilhaSelect}
        />
        <Select
          name="segmentoId"
          label="Segmento:"
          placeholder="Segmento:"
          options={prependTodosOption(optionsSegmento)}
          noOptionsMessage="Grupo não encontrado"
          onChange={onChangeSegmento}
          isDisabled={!temSegmento}
          {...segmentoSelect}
        />

       <Select
          name="bloqueado"
          label="Bloqueado:"
          placeholder="Todos:"
          options={optionsBloqueado}
          onChange={onChangeBloqueado}
          isDisabled={!temBloqueado}
          {...bloqueadoSelect}
        />

        <Select
          name="microrregiao"
          label="Microrregião:"
          placeholder="Microrregião:"
          options={prependTodosOption(optionMicroRegioes)}
          noOptionsMessage="Microrregião não encontrada"
          onChange={onChangeMicroRegiao}
          isDisabled={!temMicro}
          {...microRegiaoSelect}
        />
        <Select
          label="Cidade:"
          placeholder="Cidade:"
          options={prependTodosOption(optionCidades)}
          noOptionsMessage="Cidade nao encontrada"
          onChange={onChangeCidade}
          spacingControl={true}
          isDisabled={!temCidade}
          {...cidadeSelect}
        />

        <Select
          name="tipo"
          label="Tipo Cliente:"
          placeholder="Tipo Cliente:"
          options={optionsTipoPessoa}
          onChange={onChangeTipo}
          isDisabled={!tipoVariado}
          {...tipoPessoaSelect}
        />
      </div>

      {/* <div
        className=" container flex justify-end items-center gap-x-2  cursor-pointer bg-white border-terciaria border-x py-4 px-6"
        ref={buttonRef}
        onClick={handleClearFilters}
      >
        <CleanFiltersIcon />
        <span className="desc cursor-pointer font-bold">Limpar Filtros</span>
      </div> */}
    </>
  );
};

export default SearchClient;
